import { render, staticRenderFns } from "./ResultCardMobile.vue?vue&type=template&id=672f1784"
import script from "./ResultCardMobile.vue?vue&type=script&lang=js"
export * from "./ResultCardMobile.vue?vue&type=script&lang=js"
import style0 from "./ResultCardMobile.vue?vue&type=style&index=0&id=672f1784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports